import { getMetadata } from '~loader/loader-utils';
import { getSelectedPagesByUser } from '../../getSelectedPagesByUser';
import { getUser } from '~src/user';
import { getGridParameters } from '~core/grigliaProvino';
import { generateGridWithFixedMargins } from './generateGridWithFixedMargins';

// Mitsubishi CP 5000 con carta 10 x 15 (PE-1160, richiesto da Campo dei Fiori)
// Foglio orizzontale di 157,82 x 103,63 mm, la pagina che il driver
// MITSUBISHI CP-W5000D usa per la carta 10 x 15: con un foglio di 152 x 102 mm
// la stampa al 100% non combacia. 2 ricordini verticali impaginati "in basso
// all'esterno": ognuno in un angolo inferiore, a filo del bordo inferiore e
// del proprio bordo laterale.
// Con ricordini da 6 x 9 cm (60 x 90 mm):
//   ricordino sinistro a 0mm, ricordino destro a 97,82mm dal bordo sinistro
//   13,63mm liberi sopra (103,63 - 90) e 37,82mm tra i due ricordini
//   (157,82 - 2 x 60)
// Margini e spaziatura si ricavano dal formato del ricordino: anche con un
// formato diverso i ricordini restano negli angoli in basso.
const getStaticGridParameters = ({ format, pdf }) => ({
  pdf: {
    topMargin: pdf.height - format.height, // a filo del bordo inferiore
    leftMargin: 0, // a filo del bordo sinistro
  },
  rowInfo: {
    maxItemsToFit: 2,
    padding: pdf.width - 2 * format.width, // secondo ricordino a filo del bordo destro
  },
  columnInfo: {
    maxItemsToFit: 1,
    padding: 0,
  },
});

export default async function generateGrid() {
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const gridParameters = getGridParameters();

  return generateGridWithFixedMargins({
    staticGridParameters: getStaticGridParameters(gridParameters),
    gridParameters,
    selectedPagesByUser,
    metadata,
    user,
  });
}
